module.exports = __webpack_public_path__ + "media/splash/launch-1668x2224-2e21351d.png";